module.exports = __webpack_public_path__ + "img/reverse-allow.e9ea982e.svg";